import AdminHierarchyTree from './AdminHierarchyTree'
import { BrandHubProvider } from './BrandHubContext'

export default function AdminBrandHub() {
  return (
    <BrandHubProvider>
      <div className="flex min-h-[358px] flex-col">
        <div className="flex items-center justify-between">
          <h2 className="helix-display-small">Brand Hub</h2>
        </div>
        <div className="flex">
          <AdminHierarchyTree />
        </div>
      </div>
    </BrandHubProvider>
  )
}
